const createEnvironmentFlags = (development = false, staging = false, production = false) => ({
  development,
  staging,
  production,
});

const flags = {
  uploadcareWidget: createEnvironmentFlags(true, true, true), // INV-1603
  uploadcareMinCrop: createEnvironmentFlags(true, true, true),
  modularizedRegistryTile: createEnvironmentFlags(true, true, true), // remove old components
  cartViewedEvent: createEnvironmentFlags(true, true, true),
  fastFacets: createEnvironmentFlags(true, true, false),
  seatingChartView2: createEnvironmentFlags(false, false, false), // - this is on hold
  persistentCart: createEnvironmentFlags(true, true, true),
  invitesPlacementCards: createEnvironmentFlags(true, false, false), // INVITES-1172
  fontRenderFix: createEnvironmentFlags(true, true, false), // INVITES-1054
  pdpModalModule: createEnvironmentFlags(true, true, true),
  publicWebNavCartModal: createEnvironmentFlags(true, true, true),
  newPlpCardTile: createEnvironmentFlags(false, false, false), // INV-501
  useSharedContentEditor: createEnvironmentFlags(false, false, false), // INV-499
  singleSampleNoFoil: createEnvironmentFlags(true, true, true), // INV-784
  confirmExitModalFlag: createEnvironmentFlags(true, true, false), // WEDDINGS-1785
  invitesMagnetSilhouettePrice: createEnvironmentFlags(true, true, true), // INV-1013
  invitesCardCorrectionReviewBanner: createEnvironmentFlags(true, true, true), // INV-1085
  invitesTipModalsWithLinks: createEnvironmentFlags(true, true, true), // INV-1141 & INV-1145
  invitesReviewTipsAllModals: createEnvironmentFlags(true, true, true), // INV-1231
  invitesComparisonModuleMvp: createEnvironmentFlags(true, true, true), // INV-1107
  invitesShotkeyOrderByCardType: createEnvironmentFlags(true, true, true), // INV-1202
  invitesRelatedSameCardType: createEnvironmentFlags(true, true, true), // INV-1209
  invitesLetterpressFilter: createEnvironmentFlags(true, true, true), // INV 1154
  invitesLetterpressMvp: createEnvironmentFlags(true, true, true), // INV-1009
  invitesDynamicReviewMinimumQuantity: createEnvironmentFlags(true, true, true),
  invitesLetterpressSingleSample: createEnvironmentFlags(true, true, true), // INV-1164
  invitesSingleSampleModal: createEnvironmentFlags(true, true, true), // INV-1265
  invitesSingleSampleModalPDP: createEnvironmentFlags(true, true, true), // INV-1265
  invitesSinglesampleSaveToDraftsOnExit: createEnvironmentFlags(true, true, true), // INV-1265
  invitesSingleSampleLimitScreen: createEnvironmentFlags(true, true, true), // INV-1265
  invitesSingleSampleCustomizeStep: createEnvironmentFlags(true, true, true), // INV-1597
  invitesMultiSampleFlow: createEnvironmentFlags(true, true, true), // INV-1541
  invitesMultiSampleFlowUploadcare: createEnvironmentFlags(true, true, true), // INV-1541
  invitesMultiSampleTutorialModal: createEnvironmentFlags(true, true, true), // INV-1541
  invitesSingleSampleFoilDropdown: createEnvironmentFlags(true, true, true), // INV-1762
  blockRSVPPublish: createEnvironmentFlags(true, true, true), // - check this
  flagEventFormModalV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1840: Remove old component files
  flagGuestListMobileFix: createEnvironmentFlags(true, true, true), // WEDDINGS-1820
  isGuestListTrackingEvents: createEnvironmentFlags(true, true, true), // WEDDINGS-1888
  guestListActivationV2: createEnvironmentFlags(true, true, true), // Part 1 - WEDDINGS-1909 -ready: remove old component files
  addBannerAdToPLP: createEnvironmentFlags(true, true, true), // INV-1139
  addBottomBannerToPDP: createEnvironmentFlags(true, true, true), // INV-1140
  isSpreadsheetUploadTracking: createEnvironmentFlags(true, true, true), // WEDDINGS-1910
  isRequestMissingInfoModal: createEnvironmentFlags(true, true, true), // WEDDINGS-1870
  invitesGuestFontOverrides: createEnvironmentFlags(true, true, true), // INV-1066
  enclosuresInInvitesFlow: createEnvironmentFlags(true, true, true), // INV-1108
  usePreCheckoutSuggestionsModal: createEnvironmentFlags(true, true, true), // INV-1149
  seatingChartLanding: createEnvironmentFlags(true, true, true), // WED-1927
  hotelPlannerBanner: createEnvironmentFlags(true, false, false), // WED-1939 part 2 - on hold indefinitely?
  weddingShopModalAb: createEnvironmentFlags(true, true, true), // INV-1210
  changeTheDateCardType: createEnvironmentFlags(true, true, true), // INV-1259
  websitePSA: createEnvironmentFlags(true, true, true), // WED-1955 - **COVID Banner**
  enableMostWantedTest: createEnvironmentFlags(true, true, true), // REGISTRY-4238
  skinnyBannerRedesign: createEnvironmentFlags(true, true, true), // INV-1347
  rsvpImageUploader: createEnvironmentFlags(true, true, true),
  plpElopementFilter: createEnvironmentFlags(true, true, true), // INV-1405
  plpNoPhotoFilter: createEnvironmentFlags(true, true, true), // INV-1246
  expeditedShipping: createEnvironmentFlags(true, true, true), // INV-1439
  expeditedShippingModal: createEnvironmentFlags(false, false, false), // INV-1439
  collapsibleNav: createEnvironmentFlags(true, true, true), // REGISTRY-4436
  proofAllCardTypes: createEnvironmentFlags(true, true, true), // INV-1468
  singleSampleOrderDrawer: createEnvironmentFlags(true, true, true), // INV-1455
  magnetFoilSingleSample: createEnvironmentFlags(true, true, true), // INV-1502
  newSizesHC: createEnvironmentFlags(true, true, true), // INV-1532
  stampFoilHC: createEnvironmentFlags(true, true, true), // INV-1675
  newSizesTY: createEnvironmentFlags(true, true, true), // INV-1532
  envelopeVariationDefault: createEnvironmentFlags(true, true, true), // INV-1533
  colouredEnvelope: createEnvironmentFlags(true, true, true), // INV-1573
  fetchListedCardDataOnly: createEnvironmentFlags(true, true, true),
  freeCustomFoilEvent: createEnvironmentFlags(false, false, false), // INV-1562 // INV-1789
  hideAds: createEnvironmentFlags(false, false, false), // INV-1524
  singleSampleEnvelopes: createEnvironmentFlags(true, true, false), // INV-1588
  singleSampleWebsiteAccessPoint: createEnvironmentFlags(true, true, true), // INV-1567
  bleedRedesign: createEnvironmentFlags(true, true, true), // INV-1673
  albumsCore: createEnvironmentFlags(true, true, true), // INV-1615
  guestInfoPrepopulate: createEnvironmentFlags(true, true, true), // ISSUES-6318
  simpleSignUp: createEnvironmentFlags(true, true, true), // INV-1765
  staticMaps: createEnvironmentFlags(true, true, true), // CE-625
};

const getEnvironment = () => {
  const zolaEnv = window.zola && window.zola.env;
  switch (zolaEnv) {
    case 'development':
    case 'dev':
      return 'development';
    case 'staging':
    case 'stage':
      return 'staging';
    case 'production':
    case 'prod':
      return 'production';
    default:
      return 'production';
  }
};

const get = flag => {
  if (flags[flag]) {
    return Boolean(flags[flag][getEnvironment()]);
  }
  return false;
};

export default {
  get,
  getEnvironment,
};



// WEBPACK FOOTER //
// ./src/util/featureFlags.js